// REACT IMPORTS
import { useMemo } from "react";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// COMPONENT IMPORTS
import { useAppSelector } from "store/hooks";
import { RootState } from "store/store";
import {
  getCountryAndState,
  downloadAttachment,
  getAttachmentList,
} from "store/services/documentsServices";

interface InitialState {
  attachmentList: any;
}

const initialState: InitialState = {
  attachmentList: {},
};

export const attachmentListGet = createAsyncThunk(
  "attachment-list/get",
  async (params: any) => {
    return await getAttachmentList(params);
  }
);

export const attachmentDownload = createAsyncThunk(
  "attachment/download",
  async (params: any) => {
    return await downloadAttachment(params);
  }
);

export const countryAndState = createAsyncThunk(
  "countries-with-states/get",
  async () => {
    return await getCountryAndState();
  }
);

const prepareData = (payload: any) => {
  let data: any = payload?.data;

  const getByTitle = (title: string) => {
    const parts = title.split("_");
    if (parts.length > 1 && parts[0] !== "Agreement") {
      return parts[parts.length - 1];
    } else {
      return title;
    }
  };
  let ndata = data?.map((val: any) => {
    return {
      ...val,
      newTitle: getByTitle(val?.title),
    };
  });

  return { ...payload, data: ndata };
};

/* ------------------------------------- DOCUMNET SLICE ------------------------------------- */

const documentsSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    clearDocumentSlice: (state) => {
      for (const key in initialState) {
        if (initialState.hasOwnProperty(key)) {
          const typedKey = key as keyof typeof initialState;
          state[typedKey] = initialState[typedKey];
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      attachmentListGet.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.attachmentList = prepareData(action.payload?.body);
      }
    );
  },
});

export const { clearDocumentSlice } = documentsSlice.actions;
export default documentsSlice.reducer;

const selectAttachmentList = (state: RootState) =>
  state.document.attachmentList;
export const useAttachmentList = () => {
  const attachmentList = useAppSelector(selectAttachmentList);
  return useMemo(() => attachmentList, [attachmentList]);
};
